/* eslint-disable @trello/disallow-filenames */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { isTrelloUrl, isUrl } from '@trello/urls';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseTrelloUrl = function (url: any) {
  if (!isUrl(url) || !isTrelloUrl(url)) {
    return { type: 'unknown' };
  }

  const parsed = new URL(url);
  // eslint-disable-next-line prefer-const
  let [identifier, shortLink] = Array.from(parsed.pathname.split('/').slice(1));

  const type = (() => {
    switch (identifier) {
      case 'b':
        return 'board';
      case 'c':
        return 'card';
      case 'e':
        return 'enterprise';
      default:
        return 'unknown';
    }
  })();

  // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  shortLink = ['card', 'board'].includes(type) ? shortLink : undefined;

  return {
    type,
    shortLink,
  };
};
